import React from 'react';
import styles from './FilterDropdown.module.scss';

interface FilterDropdownProps {
  isOpen: boolean;
  selectedValues: string[];
  onValueChange: (values: string[]) => void;
  options: string[];
  onClose: () => void;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  isOpen,
  selectedValues,
  onValueChange,
  options,
  onClose
}) => {
  // Handle clicking outside dropdown to close it
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (isOpen && !target.closest('[data-filter-container]') && !target.closest('[data-filter-dropdown]')) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleOptionClick = (option: string) => {
    if (selectedValues.includes(option)) {
      onValueChange(selectedValues.filter(item => item !== option));
    } else {
      onValueChange([...selectedValues, option]);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.filterDropdown} data-filter-dropdown>
      <div className={styles.filterDropdownHeader}>
        Search by:
      </div>
      {options.map((option) => (
        <div 
          key={option}
          className={styles.filterOption}
          onClick={(e) => {
            e.stopPropagation();
            handleOptionClick(option);
          }}
        >
          <div className={styles.optionContent}>
            <div className={styles.checkboxContainer}>
              {selectedValues.includes(option) && (
                <svg 
                  className={styles.checkIcon} 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
                >
                  <polyline points="20,6 9,17 4,12"></polyline>
                </svg>
              )}
            </div>
            <span className={styles.optionLabel}>{option}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FilterDropdown; 